// URL utilisable d'une image du site : les médias envoyés par l'admin sont servis par l'API
// (chemin relatif « /api/public/media/... ») -> on préfixe avec l'URL du backend.
export function mediaUrl(u) {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
}

// Pages privées (admin, espace auto-école, connexion) : ni pop-up, ni Clarity.
const PRIVATE_PREFIXES = ["/admin", "/pro", "/qualif", "/connexion", "/mot-de-passe-oublie", "/reinitialiser-mot-de-passe"];
export function isPrivatePath(pathname = "") {
  return PRIVATE_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`));
}
